import { render, staticRenderFns } from "./ShareDocument.vue?vue&type=template&id=15832167&"
import script from "./ShareDocument.vue?vue&type=script&lang=js&"
export * from "./ShareDocument.vue?vue&type=script&lang=js&"
import style0 from "./ShareDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports